import React, { useState, useEffect } from 'react';
import './WhyChooseUs.css';
import { FaChevronDown, FaChevronUp } from 'react-icons/fa'; 

const WhyChooseUs = () => {
  const [activeQuestion, setActiveQuestion] = useState(null);

  const toggleAnswer = (index) => {
    setActiveQuestion(activeQuestion === index ? null : index); // Toggle answer visibility
  };

  useEffect(() => {
    // Select all FAQ items
    const faqItems = document.querySelectorAll('.faq-item');

    const options = {
      root: null, // Use the viewport as the root
      rootMargin: '0px',
      threshold: 0.1, // Trigger the callback when 10% of the element is in the viewport
    };

    // IntersectionObserver callback function
    const handleIntersection = (entries, observer) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          // Add 'revealed' class to trigger animation
          entry.target.classList.add('revealed');
        } else {
          // Remove 'revealed' class when the element is out of view
          entry.target.classList.remove('revealed');
        }
      });
    };

    // Initialize observer
    const observer = new IntersectionObserver(handleIntersection, options);

    // Observe all FAQ items
    faqItems.forEach(item => observer.observe(item));

    // Cleanup observer on unmount
    return () => {
      faqItems.forEach(item => observer.unobserve(item));
    };
  }, []);

  return (
    <div className="why-choose-us">
      <div className="content">
        <h2>Why Choose Us?</h2>
        <div className="faq">
          <div className="faq-item">
            <div className="faq-question" onClick={() => toggleAnswer(1)}>
              <h4>What sets Dreamscape Studios apart from other production companies?</h4>
              {activeQuestion === 1 ? <FaChevronUp /> : <FaChevronDown />}
            </div>
            {activeQuestion === 1 && <p className="answer">
              Dreamscape Studios stands out by blending years of expertise with a passion for storytelling. Our team delivers top-tier video production services, from videography production to corporate video filming. With a focus on creativity and precision, we offer end-to-end services, ensuring your brand's vision is brought to life. Whether you need a commercial, promotional video, or full video production, Dreamscape Studios offers high-quality results from pre-production to post-production.
            </p>}
          </div>
          <div className="faq-item">
            <div className="faq-question" onClick={() => toggleAnswer(2)}>
              <h4>How do you handle tight deadlines and complex projects?</h4>
              {activeQuestion === 2 ? <FaChevronUp /> : <FaChevronDown />}
            </div>
            {activeQuestion === 2 && <p className="answer">
We thrive under pressure. Our project management team works seamlessly to keep everything on track, ensuring deadlines are met without compromising on quality. Our experience in managing complex video production services allows us to adapt quickly and efficiently, whether it's video creation, corporate video production, or video filming. We maintain a high level of professionalism throughout the entire production firm process, delivering top-tier results on time.            </p>}
          </div>
          <div className="faq-item">
            <div className="faq-question" onClick={() => toggleAnswer(3)}>
              <h4>What kind of support can we expect throughout the production process?</h4>
              {activeQuestion === 3 ? <FaChevronUp /> : <FaChevronDown />}
            </div>
            {activeQuestion === 3 && <p className="answer">
From start to finish, we’re fully committed to supporting you at every step. Whether you're looking for video production services, videography company expertise, or just need updates on video filming, we’re always here to help. Our team keeps communication open and ensures you're involved in all decisions, making sure the final result reflects your vision. We make the process smooth, whether it’s video creation or corporate video production, so you never feel out of the loop.
            </p>}
          </div>
        </div>
      </div>
    </div>
  );
};

export default WhyChooseUs;
